import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  input {
    width: 6rem;
    height: 6rem;
    margin-left: 2rem;
  }
  input:checked {
    background: ${(props) => props.theme.colors.SELECTED};
  }

  label {
    direction: rtl;
    text-align: right;
    font-size: 3rem;
  }
`;
